/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRateHeader.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/rate-header";

export class AutogenModelRateHeader<RowType extends ModelRow> extends Endpoint<RowType, RowRateHeaderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRateHeader extends ModelRow<RowRateHeaderFields> {
	constructor(values?: Partial<RowRateHeaderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRateHeaderFields {
	company_id: string;
	currency: string;
	distance_um: string;
	id: string;
	ltl: string;
	method: string;
	mile_type: string;
	minimum_weight: number;
	minimum_weight_um: string;
	product: string;
	remark: string;
	weight_um: string;
}

